import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ViewXeroInvoices from './viewXeroInvoices';

if (document.getElementById('react-component-logistics-portal-view-customer-xero-invoices')) {
  ReactDOM.render(
    <ViewXeroInvoices/>,
    document.getElementById('react-component-logistics-portal-view-customer-xero-invoices')
  );
}